import type { AutoCoderFrameworkLibrary } from '../hooks/useFrameworkLibrary'

export interface FrameworkTiers {
  company: AutoCoderFrameworkLibrary[]
  mine: AutoCoderFrameworkLibrary[]
  colleagues: AutoCoderFrameworkLibrary[]
}

// The AutoCoder code frame library in Data Viz's three tiers (Adam, 23 Sep:
// "the same three tiers as data"). Company-level is what a Manager promoted;
// the rest splits by who made it.
export const groupFrameworkTiers = (frameworks: AutoCoderFrameworkLibrary[], userEmail?: string): FrameworkTiers => {
  const me = (userEmail || '').toLowerCase()
  const tiers: FrameworkTiers = { company: [], mine: [], colleagues: [] }
  for (const framework of frameworks) {
    if (framework.visibility === 'company') tiers.company.push(framework)
    else if (me && (framework.created_by || '').toLowerCase() === me) tiers.mine.push(framework)
    else tiers.colleagues.push(framework)
  }
  return tiers
}
